module.exports = __webpack_public_path__ + "img/bobido_bobocoin.gm.265f28c.png";